import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import BioentityStorablesView from './BioentityStorablesView';
import StorageTabState from './StorageTabState';

class StorageTabView extends BufferTabView<StorageTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override render(): this {
    const model = this.model.get('model');
    this.reactRoot = renderToDOM(
      <BioentityStorablesView
        bioentityId={model.id}
        permissions={model.permissions()}
        tagSchema={model.tagSchema()}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

StorageTabView.prototype.className = 'buffer-tab buffer-tab-reset buffer-tab--no-padding';

export default StorageTabView;
